import {
  Box,
  FormControl,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
import { useEffect, useState } from "react";
import marker from "../../../images/Markers.png";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
  },
  boxRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
  },
  typography: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 600,
    color: "#063F5E",
  },
  stackText: { width: "100%" },
};

export default function LoginStep({
  dadosPaciente,
  setDadosPaciente,
  setValidacaoFalhou
}) {
  const [confirmacaoEmail, setConfirmacaoEmail] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [termoDeUso, setTermoDeUso] = useState(false);
  const [termoDePrivacidade, setTermoDePrivacidade] = useState(false);
  const [emailsIguais, setEmailsIguais] = useState(true);
  const [senhasIguais, setSenhasIguais] = useState(true);
  const [senhaValida, setSenhaValida] = useState(true);

  useEffect(() => {
    setValidacaoFalhou(
      !emailsIguais ||
      !senhasIguais ||
      !senhaValida
    );
  }, [senhasIguais, emailsIguais, senhaValida]);

  const handleChangeEmail = (event) => {
    setDadosPaciente((prevState) => ({
      ...prevState,
      email: event.target.value,
    }));

    if (event.target.value === confirmacaoEmail || confirmacaoEmail === "") {
      setEmailsIguais(true);
    } else {
      setEmailsIguais(false);
    }
  };

  const handleRepetirEmail = (event) => {
    setConfirmacaoEmail(event.target.value);
    if (event.target.value === dadosPaciente.email) {
      setEmailsIguais(true);
    } else {
      setEmailsIguais(false);
    }
  };

  const handleSenha = (event) => {
    setDadosPaciente((prevState) => ({
      ...prevState,
      senha: event.target.value,
    }));

    if (event.target.value.length < 6 || event.target.value.length > 20) {
      setSenhaValida(false);
    }else{
      setSenhaValida(true);
    }

    if (event.target.value === confirmarSenha || confirmarSenha === "") {
      setSenhasIguais(true);
    } else {
      setSenhasIguais(false);
    }
  };

  const handleRepetirSenha = (event) => {
    setConfirmarSenha(event.target.value);
    if (event.target.value === dadosPaciente.senha) {
      setSenhasIguais(true);
    } else {
      setSenhasIguais(false);
    }
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna1"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            E-mail <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            type="email"
            value={dadosPaciente.email}
            fullWidth
            onChange={handleChangeEmail}
          />
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Repetir E-mail <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            type="email"
            value={confirmacaoEmail}
            error={!emailsIguais}
            helperText={!emailsIguais && "Os e-mails devem ser iguais."}
            fullWidth
            onChange={handleRepetirEmail}
          />
        </Stack>
      </Box>

      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna2"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Senha <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            type="password"
            value={dadosPaciente.senha}
            fullWidth
            onChange={handleSenha}
            error={!senhaValida}
            helperText={!senhaValida && 
            <Typography sx={{ fontSize: "12px", ml: -1.5 }}>
              Sua senha deve ter entre 6 e 20 digitos
            </Typography>
          }
          />
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Confirmar Senha <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            type="password"
            value={confirmarSenha}
            fullWidth
            onChange={handleRepetirSenha}
            error={!senhasIguais}
            helperText={!senhasIguais && "As senhas devem ser iguais."}
          />
        </Stack>
      </Box>
      <Stack direction={"column"}>
        <Typography sx={styles.typography}>Política de Privacidade</Typography>

        <FormControl sx={{ mt: "16px" }}>
          <FormControlLabel
            label={
              <Box style={styles.checkboxText}>
                Desejo receber notificações por e-mail
              </Box>
            }
            control={
              <Checkbox
                checked={termoDeUso}
                onChange={(event) => {
                  setTermoDeUso(event.target.checked);
                }}
              />
            }
          />
        </FormControl>

        <FormControl>
          <FormControlLabel
            label={
              <Box style={styles.checkboxText}>
                Eu li e concordo com os Termos e Condições
              </Box>
            }
            control={
              <Checkbox
                required
                checked={termoDePrivacidade}
                onChange={(event) => {
                  setTermoDePrivacidade(event.target.checked);
                }}
              />
            }
          />
        </FormControl>
      </Stack>
    </Box>
  );
}
